import { render, staticRenderFns } from "./BloqueIframe.vue?vue&type=template&id=1be57855&scoped=true"
import script from "./BloqueIframe.vue?vue&type=script&lang=js"
export * from "./BloqueIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be57855",
  null
  
)

export default component.exports